import moment, { Moment } from 'moment';

export default class GroupingUnitItem {
    public id: number;
    public project: string;
    public vacant: string;
    public address: string;
    public residents: number;
    public titleNumber: number;

    constructor(
        id: number,
        project: string,
        vacant: string,
        address: string,
        residents: number,
        titleNumber: number,
    ) {
        this.id = id;
        this.project = project;
        this.vacant = vacant;
        this.address = address;
        this.residents = residents;
        this.titleNumber = titleNumber;
    }
}
